namespace GeniuzPOS.Points {
    export namespace PermissionKeys {
        export const General = "";

        namespace PointCampaign {
            export const Delete = "3Member:Points:\u0E40\u0E07\u0E37\u0E48\u0E2D\u0E19\u0E44\u0E02\u0E01\u0E32\u0E23\u0E2A\u0E30\u0E2A\u0E21\u0E41\u0E15\u0E49\u0E21:Delete";
            export const Modify = "3Member:Points:\u0E40\u0E07\u0E37\u0E48\u0E2D\u0E19\u0E44\u0E02\u0E01\u0E32\u0E23\u0E2A\u0E30\u0E2A\u0E21\u0E41\u0E15\u0E49\u0E21:Modify";
            export const View = "3Member:Points:\u0E40\u0E07\u0E37\u0E48\u0E2D\u0E19\u0E44\u0E02\u0E01\u0E32\u0E23\u0E2A\u0E30\u0E2A\u0E21\u0E41\u0E15\u0E49\u0E21:View";
        }

        namespace PointRedeemItem {
            export const Delete = "3Member:Points:\u0E41\u0E15\u0E49\u0E21\u0E41\u0E25\u0E01\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32:Delete";
            export const Modify = "3Member:Points:\u0E41\u0E15\u0E49\u0E21\u0E41\u0E25\u0E01\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32:Modify";
            export const View = "3Member:Points:\u0E41\u0E15\u0E49\u0E21\u0E41\u0E25\u0E01\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32:View";
        }
    }
}
